import { jsx as p, jsxs as C } from "react/jsx-runtime";
import { forwardRef as G } from "react";
import N from "clsx";
import { Field as D } from "../Field/Field.js";
import { IconCaret as E } from "../Icons/index.js";
import { mergeClasses as F } from "../../utils/merge-classes.js";
import { PlaceholderSelectOption as I, defaultOptionValue as k, SelectOption as q } from "./Option/SelectOption.js";
import { SelectOptGroup as z } from "./OptGroup/SelectOptGroup.js";
import { SelectDivider as A } from "./Divider/SelectDivider.js";
const m = G(
  ({
    // `Field` props
    autoFocus: r,
    className: e,
    defaultValue: t,
    disableAnimation: f,
    errorText: d,
    helperText: u,
    id: S,
    isDisabled: c,
    isInvalid: b,
    isRequired: O,
    labelText: g,
    name: x,
    size: s,
    value: o,
    // Component-specific props
    children: w,
    icon: l,
    placeholder: i,
    // Control-specific props
    onChange: h,
    // Spread any additional props passed by the user (such as custom `data-*` attributes)
    ...a
  }, j) => {
    o == null && i && !t && (t = k);
    const v = B(s, !!l);
    return /* @__PURE__ */ p(
      D,
      {
        autoFocus: r,
        className: e,
        defaultValue: t,
        disableAnimation: f,
        errorText: d,
        helperText: u,
        iconEnd: /* @__PURE__ */ p(E, { size: "md", variant: "down" }),
        iconStart: l,
        id: S,
        isDisabled: c,
        isInvalid: b,
        isRequired: O,
        labelText: g,
        name: x,
        size: s,
        type: "select",
        value: o,
        children: ({ className: y, ...n }) => ("aria-label" in n && "aria-labelledby" in a && delete n["aria-label"], /* @__PURE__ */ C(
          "select",
          {
            ...n,
            className: F(
              N(
                y,
                // When clicking on the `container` in the `Field` component,
                // the focus moves to the select, but the options list doesn't open
                // due to gaps around the control that don't activate it.”
                // To fix this, we stretch the `select` from edge to the other within the `container`.
                // This will enable the options list to be activated by clicking anywhere within the `container`.
                "absolute",
                // Host: `container` in `Field`
                "bottom-0 left-0 right-0 top-0",
                "appearance:none",
                // Resets browser styles
                "bg-color-static-transparent",
                "focus:outline-none",
                c ? "cursor-not-allowed" : "cursor-pointer",
                v
              )
            ),
            onChange: h,
            ref: j,
            ...a,
            children: [
              i && /* @__PURE__ */ p(I, { children: i }),
              w
            ]
          }
        ))
      }
    );
  }
);
m.Option = q;
m.OptGroup = z;
m.Divider = A;
function B(r = "md", e) {
  switch (r) {
    case "xs":
      return [e ? "ps-350" : "ps-100", "pe-350"];
    case "sm":
      return [e ? "ps-500" : "ps-150", "pe-500"];
    case "md":
      return [e ? "ps-[2.75rem]" : "ps-200", "pe-[2.75rem]"];
  }
}
export {
  m as Select
};
